import { createDraftSafeSelector, createSelector } from '@reduxjs/toolkit'
import { UserRoleEnum } from 'shared/models/User'
import userApi from './user.service'

export const getUser = userApi.endpoints.getUser.select()
export const getUserSettings = userApi.endpoints.getUserSettings.select()

export const getUserRoles = userApi.endpoints.getUserRoles.select()

export const isUserMember = createSelector(getUser, (state) =>
  state.data?.roles?.some((x) => x.role === UserRoleEnum.member)
)

export const getClientWithRoleAndClientId = createDraftSafeSelector(
  [getUserRoles],
  (roles) => (role: UserRoleEnum, clientId: string) =>
    roles?.data
      ?.filter((x) => x.role === role)
      .find(({ reference }) =>
        reference.some(
          ({ type, value }) => type === 'ClientId' && value === clientId
        )
      )
)

export const getUserFullname = createSelector(getUser, (state) => {
  if (!state.data) return ''

  return `${state.data.firstname ? state.data.firstname + ' ' : ''}${
    state.data.surname
  }`
})
